// extracted by mini-css-extract-plugin
export var listwrap = "newsList-module--listwrap--3_I2n";
export var list = "newsList-module--list--2G0N2";
export var jsAnimInit = "newsList-module--jsAnimInit--2HTpi";